export default __webpack_public_path__ + "images/d2fc6f57019f4de945d9556cb062bf1b.svg";